
@if(this.isFetchingData){
    <div id="grid_fetching_data">
        <img src="./assets/imgs/logo_marving.jpg"/>
         <div id="msg_loading">{{ 'LOADING' | translate }}</div>
         <ion-spinner></ion-spinner>
    </div>
}

<ion-app [class]="{'content_with_menu': this.menuService.isEnabled}">    
    <app-menu></app-menu>
    <ion-router-outlet></ion-router-outlet>   
    <app-alert-modal></app-alert-modal>
</ion-app>
